export interface AircraftOption {
  name: string;
  category: string;
  defaultSeats: number;
}

export const aircraftOptionsNetJets: AircraftOption[] = [
  // Light Cabin
  { name: 'Embraer Phenom 300/300E', category: 'Light Cabin', defaultSeats: 6 },
  { name: 'Cessna Citation Latitude', category: 'Light Cabin', defaultSeats: 8 },

  // Midsize Cabin
  { name: 'Cessna Citation XLS/XLS+', category: 'Midsize Cabin', defaultSeats: 8 },
  { name: 'Cessna Citation Latitude', category: 'Midsize Cabin', defaultSeats: 8 },

  // Super-Midsize Cabin
  { name: 'Cessna Citation Sovereign/Sovereign+', category: 'Super-Midsize Cabin', defaultSeats: 9 },
  { name: 'Cessna Citation Longitude', category: 'Super-Midsize Cabin', defaultSeats: 8 },

  // Large Cabin/Heavy Jets
  { name: 'Bombardier Challenger 350', category: 'Large Cabin/Heavy Jet', defaultSeats: 10 },
  { name: 'Bombardier Challenger 650', category: 'Large Cabin/Heavy Jet', defaultSeats: 12 },
  { name: 'Bombardier Global 5500', category: 'Large Cabin/Heavy Jet', defaultSeats: 14 },
  { name: 'Bombardier Global 6500', category: 'Large Cabin/Heavy Jet', defaultSeats: 14 },
  { name: 'Bombardier Global 7500', category: 'Large Cabin/Heavy Jet', defaultSeats: 14 },

  // Other
  { name: 'Other', category: 'Other', defaultSeats: 0 }
];